import { AnalyticsPayload, MatchedAudience } from 'ts-types';
import { makePostRequest, getCleanUrl } from '../utils';
import { getTotalPageViews } from './pageviews';
import { SequenceAnalytics } from './sequences';
import { proberAnalytics } from './prober';
import { prebidAnalytics } from './prebid';
import { ANALYTICS_URL } from '../constants';

export declare const DISABLE_ANALYTICS: boolean;
export declare const DISABLE_VIEWS_COUNTS: boolean;

export const logAnalytics = async (
  consentGranted: boolean,
  matchedAudiences: MatchedAudience[],
  featuresAvailable: boolean | undefined
): Promise<void> => {
  if (DISABLE_ANALYTICS) return;

  const { apiKey, accountId, publisherId, loadId } = (<any>(
    window
  )).edktInitializor;

  const url = getCleanUrl();
  const [prober, toSequence] = await Promise.all([
    proberAnalytics.get(),
    prebidAnalytics(),
  ]);
  const sequenceAnalytics = new SequenceAnalytics(loadId);
  const sequences = sequenceAnalytics.get(toSequence);
  const totalPageViews = getTotalPageViews();
  // TODO: obfuscate the payload key names.
  // But document in the code / types.
  const payload: AnalyticsPayload = {
    url,
    accountId,
    publisherId,
    consentGranted,
    matchedAudiences,
    // TODO: Should be an optional key, similar to sequences
    prober,
    ...(sequences && { sequences }),
    featuresAvailable,
    totalPageViews,
  };

  await makePostRequest(ANALYTICS_URL, JSON.stringify(payload), apiKey, loadId);
};
